import { render, staticRenderFns } from "./ThreadsList.vue?vue&type=template&id=09f80d0b&scoped=true"
import script from "./ThreadsList.vue?vue&type=script&lang=js"
export * from "./ThreadsList.vue?vue&type=script&lang=js"
import style0 from "./ThreadsList.vue?vue&type=style&index=0&id=09f80d0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f80d0b",
  null
  
)

export default component.exports